import { CollectionPointPageTab } from "../containers/CollectionPointPage";
import {
  BILLING_PAGE_PATH,
  COLLECTION_POINT_PAGE_PATH,
  CONTAINER_DETAIL_PAGE_PATH,
  WEIGHT_HISTORY_PAGE_PATH,
} from "../middleware/routes";

export const PREV_PAGE_PARAM = "prev-page";
export const TAB_PARAM = "tab";

const buildUrl = (basePath: string, params: Record<string, string | number | undefined>): string => {
  const query = Object.entries(params)
    .filter(([, value]) => value !== undefined)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join("&");

  return query ? `${basePath}?${query}` : basePath;
};

interface BuildCollectionPointUrlOptions {
  prevPage?: string;
  tab?: CollectionPointPageTab;
}

export const buildCollectionPointUrl = (
  collectionPointId: string | number,
  options: BuildCollectionPointUrlOptions = {}
) => {
  const { prevPage, tab } = options;

  return buildUrl(COLLECTION_POINT_PAGE_PATH, {
    id: collectionPointId,
    [PREV_PAGE_PARAM]: prevPage,
    [TAB_PARAM]: tab,
  });
};

interface BuildWeightHistoryUrlOptions {
  prevPage?: string;
}

export const buildWeightHistoryUrl = (
  locationId: string | number,
  containerId: string | number,
  { prevPage }: BuildWeightHistoryUrlOptions = {}
) => {
  return buildUrl(WEIGHT_HISTORY_PAGE_PATH, {
    id: locationId,
    cid: containerId,
    [PREV_PAGE_PARAM]: prevPage,
  });
};

interface BuildContainerDetailUrlOptions {
  prevPage?: string;
}

export const buildContainerDetailUrl = (
  locationId: string | number,
  containerId: string | number,
  options: BuildContainerDetailUrlOptions = {}
) => {
  const { prevPage } = options;

  return buildUrl(CONTAINER_DETAIL_PAGE_PATH, {
    id: locationId,
    cid: containerId,
    [PREV_PAGE_PARAM]: prevPage,
  });
};

export const buildBillingPageUrl = (billingId: string | number) => {
  return buildUrl(BILLING_PAGE_PATH, {
    id: billingId,
  });
};
